import { createApp } from 'vue'
import Test from './index.vue';
import i18n from '../../i18n';
import mitt from 'mitt';

import '../../styles/general.less';

const emitter = mitt();

const app = createApp(Test);
app.config.globalProperties.emitter = emitter;
app.use(i18n);
app.mount('#app');